import React from 'react';
import clsx from 'clsx';

import { GridItem } from './components/grid-item';
import { GridItemProps } from './';

type Props = {
  gridColumns?: 2 | 3 | 4;
  className?: string;
  items: GridItemProps[];
  textVariant?: 'light' | 'dark';
  titleVariant?: 'title' | 'body';
  variant?: 'video' | 'song';
};

export const MediaGrid: React.FC<Props> = ({
  gridColumns = 2,
  items,
  className,
  textVariant = 'light',
  titleVariant = 'title',
  variant = 'video',
}) => (
  <ul
    className={clsx(
      'grid',
      {
        'grid-cols-2 md:grid-cols-4 gap-4': gridColumns === 4,
        'grid-cols-1 md:grid-cols-3 gap-8 md:gap-4': gridColumns === 3,
        'grid-cols-1 md:grid-cols-2 gap-8 md:gap-4': gridColumns === 2,
      },
      className
    )}
  >
    {items.map(
      ({
        title,
        subtitle,
        badge,
        resourcePath,
        description,
        status,
        imageUrl,
        viewerCompletionPercentage,
        viewerHasCompleted,
        duration,
      }) => (
        <GridItem
          key={resourcePath}
          title={title}
          subtitle={subtitle}
          badge={badge}
          resourcePath={resourcePath}
          imageUrl={imageUrl}
          description={description}
          status={status}
          viewerCompletionPercentage={viewerCompletionPercentage}
          viewerHasCompleted={viewerHasCompleted}
          duration={duration}
          gridColumns={gridColumns}
          textVariant={textVariant}
          titleVariant={titleVariant}
          variant={variant}
        />
      )
    )}
  </ul>
);
